module.exports = __webpack_public_path__ + "static/img/hand.7be9648b.png";